import { useRouteLoaderData } from 'react-router'

import { AppLoaderData, Environment } from '~/types/app.ts'

export const useEnvironment = (): Environment | undefined => {
  const { env } = useRouteLoaderData<AppLoaderData>('root') || {}
  return env
}